export default __webpack_public_path__ + "static/media/01.c808ec85.jpg";